{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              71.91757491431792,
              8.745953895071949
            ],
            [
              71.59994462778383,
              -1.6836380552966688
            ],
            [
              75.66077682810521,
              -2.1329839848940253
            ],
            [
              75.26465526150886,
              3.802330164639372
            ],
            [
              73.86820606112508,
              8.373756858483844
            ],
            [
              71.91757491431792,
              8.745953895071949
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}